import React from 'react';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    tooltip?: string;
    disabledTooltip?: string;
}

export default function Button({ children, ...attributes }: Props) {
    const setToolTip = () => {
        if (attributes.disabledTooltip && attributes.disabled) {
            return attributes.disabledTooltip;
        }
        if (!attributes.disabled && attributes.tooltip) {
            return attributes.tooltip
        }
        if (attributes.tooltip) {
            return attributes.tooltip;
        }
    }

    return (
        <span title={ setToolTip() }>
            <button
                type="button"
                className={ attributes.disabled? 'disabled-standard-btn' : `${attributes.className} standard-btn`}
                disabled={ attributes.disabled }
                onClick={ attributes.onClick }
                style={ attributes.style }
            >
                {children}
            </button>
        </span>
    );
}